
import React, { useState } from "react";
import { useSnackbar } from "notistack";
import { FileUploadButton } from "../../Buttons";

const MultipleFile = ({ field = {}, onChange = () => { }, fieldValues, getImages = () => {}, imagesData = [], showFileNumbers=true, disableButton=false, changeIcon=true, style }) => {

  const [fileName, setFileName] = useState("");
  const [checkExtension, setCheckExtension] = useState(true);
  const { enqueueSnackbar } = useSnackbar();

  const error_message = "Select only jpg, jpeg, png images"
  const extensions_array = ['jpg', 'jpeg', 'png', 'JPG', 'JPEG', 'PNG', 'gif', 'GIF'];
  const handleChange = async (e) => {
    const isTrue = (currentValue) => currentValue === true;
    let check = []
    let extension = ""
    if (e.length > 5) {
      enqueueSnackbar("Max 5 images are allowed.", {
        autoHideDuration: 3000
      });
    } else {
      for(let i = 0; i < e.length; i++)
      {
        // last segment — filenames may contain dots (e.g. "Screenshot 1.40.58 PM.jpg")
        extension = e[i].name.split(".").pop()
        if (extensions_array.includes(extension)){
          check.push(true);
        } else {
          check.push(false);
        }
      }

      if (check.every(isTrue))
      {
        setCheckExtension(true)
        setFileName(e.length);
        // parent getImages appends to the existing set and caps at 5
        onChange(field, e);
        getImages(field, e)
      }
      else{
        setFileName("")
        onChange(field, )
        setCheckExtension(false)
        enqueueSnackbar(error_message, { autoHideDuration: 3000 })
      }
    }
  };

  return (
    <div style={{...{ width: '100%' }, ...style}} className={field.align ? "mb-2" : "mb-2 d-flex justify-content-end"}>
      <div style={{ width: '100%' }}>
        <FileUploadButton
          multiple ={true}
          key={field.key}
          // value={field.key}
          value={fieldValues[field.key]}
          disabled={disableButton}
          onChange={handleChange}
          tabIndex={field?.inputProps?.tabIndex}
          uploaded={fileName !== ""}
          size="small"
          label={field.formLabel || field.label || "UPLOAD FILE"}
          style={{ whiteSpace: 'nowrap' }}
          changeIcon={changeIcon}
          className="mr-2"
        />
        <label style={{ fontSize: 13, display: "block", color: "#858585", }}>{field.hint}</label>
        {
          showFileNumbers && checkExtension ?
          <div style={{ fontSize: 11, maxWidth: 200, overflowWrap: 'break-word', marginTop: 5 }}>{fileName ? fileName > 1 ? `${fileName} Files uploaded successfully` : `${fileName} File uploaded successfully` : ""}</div>
          :
          ""
        }
      </div>
    </div>
  );
};

export default MultipleFile;
